import type { SelectorObject } from '../types';

export const fixedChargesEditColumnsSelectors = {
  nameInput: 'fixed-charges-edit-columns-name-input',
  amountInput: 'fixed-charges-edit-columns-amount-input',
  removeRowButton: 'fixed-charges-edit-columns-remove-row-button',
} satisfies SelectorObject<'fixed-charges-edit-columns-'>;